function initSingle(el) {
  const elToggle = el.querySelector('[data-drawer-toggle]');
  let open = false;

  elToggle.addEventListener('click', () => {
    const action = open ? 'remove' : 'add';
    el.classList[action]('drawer--open');
    open = !open;
  });
}

function init() {
  const els = document.querySelectorAll('[data-drawer]');
  [...els].forEach(initSingle);
}

export default {init};
